import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { Auth, Analytics } from "aws-amplify";

import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LockIcon from "@material-ui/icons/Lock";

import { onAuthorizeSuccess } from "../../../redux/slices/login";

import FormErrors from "./FormErrors";
import PasswordCheck from "./PasswordCheck";
import CustomSpinner from "../../UI/Spinner/CustomSpinner";

import {
  AuthButton,
  AuthForm,
  AuthInput,
  AuthRedirectText,
  InputField,
  StyledLink,
  styleLoginIcon,
  Field,
  SpinnerContainer,
} from "../authStyle";

const StyledMailOutlineIcon = styleLoginIcon(MailOutlineIcon);
const StyledLockIcon = styleLoginIcon(LockIcon);

async function trackSignUp() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    Analytics.record({
      name: "userSignUp",
      attributes: {
        userId: user.username,
        status: "success",
        timestamp: new Date().toISOString(),
      },
    });

    // Update endpoint with user data to track repeat users
    await Analytics.updateEndpoint({
      userId: user.username,
      userAttributes: {
        email: [user.attributes.emai],
        authStatus: ['authenticated']
      },
    });
  } catch (error) {
    console.error("Error tracking sign-up:", error);
  }
}

export default function Register({ history, setHeight, onSignIn }) {
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState(null);
  const [submitEnabled, setSubmitEnabled] = useState(false);

  const [loggingIn, setLoggingIn] = useState(false);

  useEffect(() => {
    setHeight(650);
  }, [setHeight]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors(null);
    // Amplify/Cognito
    try {
      setLoggingIn(true);

      let signupData = await Auth.signUp({
        username,
        password,
      });
      console.log(signupData);

      await Auth.signIn(username, password);
      await trackSignUp();
      onSignIn(); //set animation

      //wait for animation to finish
      setTimeout(() => {
        dispatch(onAuthorizeSuccess());
      }, 750);
    } catch (error) {
      setErrors(error.message ? error : { message: error });
    }
    setLoggingIn(false);
  };

  const onUsernameChange = (e) => {
    setErrors(null);
    setUsername(e.target.value);
  };
  const onPasswordChange = (e) => {
    setErrors(null);
    setPassword(e.target.value);
  };
  return (
    <>
      {errors ? (
        <FormErrors formErrors={errors} />
      ) : (
        <PasswordCheck
          password={password}
          onSetSubmitEnabled={setSubmitEnabled}
        />
      )}

      <AuthForm onSubmit={handleSubmit}>
        {loggingIn ? (
          <SpinnerContainer>
            <CustomSpinner />
          </SpinnerContainer>
        ) : (
          <Fragment>
            <InputField>
              <StyledMailOutlineIcon fontSize="large" />
              <AuthInput
                type="text"
                id="username"
                placeholder="Email"
                value={username}
                onChange={onUsernameChange}
                required={true}
              />
            </InputField>

            <InputField>
              <StyledLockIcon fontSize="large" />
              <AuthInput
                type="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={onPasswordChange}
                required={true}
              />
            </InputField>
          </Fragment>
        )}
        <AuthButton disabled={!submitEnabled}>Sign up</AuthButton>
        <Field>
          <AuthRedirectText>Already have an account?</AuthRedirectText>
          <StyledLink to="/">Sign in</StyledLink>
        </Field>
      </AuthForm>
    </>
  );
}
